import ScalarFloating_default from "./ScalarFloating.vue.js";
import ScalarFloatingBackdrop_default from "./ScalarFloatingBackdrop.vue.js";
export { ScalarFloating_default as ScalarFloating, ScalarFloatingBackdrop_default as ScalarFloatingBackdrop };
